/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  PatientAlertStaffApiInContract,
  PatientAlertStaffApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPatientsPatientIdAlerts = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientAlertStaffApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/alerts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdAlertsInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/alerts`
    ] as const;
    }

export const getGetPatientsPatientIdAlertsQueryKey = (patientId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/alerts`
    ] as const;
    }

    
export const getGetPatientsPatientIdAlertsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdAlertsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>> = ({ signal }) => getPatientsPatientIdAlerts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdAlertsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>
export type GetPatientsPatientIdAlertsInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdAlertsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdAlertsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdAlertsInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdAlertsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdAlertsInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdAlertsQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdAlertsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>> = ({ signal }) => getPatientsPatientIdAlerts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdAlertsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>
export type GetPatientsPatientIdAlertsQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdAlerts<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlerts<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlerts<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdAlerts<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdAlertsQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdAlertsQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdAlertsQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdAlertsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdAlertsQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>> = ({ signal }) => getPatientsPatientIdAlerts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdAlertsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>
export type GetPatientsPatientIdAlertsSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdAlertsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdAlertsSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdAlertsSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdAlertsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdAlertsInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>> = ({ signal }) => getPatientsPatientIdAlerts(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdAlertsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>
export type GetPatientsPatientIdAlertsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdAlertsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdAlertsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdAlertsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdAlerts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdAlertsSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postPatientsPatientIdAlerts = (
    patientId: string,
    patientAlertStaffApiInContract: PatientAlertStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/alerts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientAlertStaffApiInContract, signal
    },
      options);
    }
  


export const getPostPatientsPatientIdAlertsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>, TError,{patientId: string;data: PatientAlertStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>, TError,{patientId: string;data: PatientAlertStaffApiInContract}, TContext> => {

const mutationKey = ['postPatientsPatientIdAlerts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>, {patientId: string;data: PatientAlertStaffApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  postPatientsPatientIdAlerts(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdAlertsMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>>
    export type PostPatientsPatientIdAlertsMutationBody = PatientAlertStaffApiInContract
    export type PostPatientsPatientIdAlertsMutationError = void | ErrorApiOutContract

    export const usePostPatientsPatientIdAlerts = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>, TError,{patientId: string;data: PatientAlertStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdAlerts>>,
        TError,
        {patientId: string;data: PatientAlertStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdAlertsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdAlertsAlertId = (
    patientId: string,
    alertId: string,
    patientAlertStaffApiInContract: PatientAlertStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/alerts/${encodeURIComponent(String(alertId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientAlertStaffApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdAlertsAlertIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string;data: PatientAlertStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string;data: PatientAlertStaffApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdAlertsAlertId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>, {patientId: string;alertId: string;data: PatientAlertStaffApiInContract}> = (props) => {
          const {patientId,alertId,data} = props ?? {};

          return  putPatientsPatientIdAlertsAlertId(patientId,alertId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdAlertsAlertIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>>
    export type PutPatientsPatientIdAlertsAlertIdMutationBody = PatientAlertStaffApiInContract
    export type PutPatientsPatientIdAlertsAlertIdMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdAlertsAlertId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string;data: PatientAlertStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdAlertsAlertId>>,
        TError,
        {patientId: string;alertId: string;data: PatientAlertStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdAlertsAlertIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deletePatientsPatientIdAlertsAlertId = (
    patientId: string,
    alertId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/alerts/${encodeURIComponent(String(alertId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePatientsPatientIdAlertsAlertIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string}, TContext> => {

const mutationKey = ['deletePatientsPatientIdAlertsAlertId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>, {patientId: string;alertId: string}> = (props) => {
          const {patientId,alertId} = props ?? {};

          return  deletePatientsPatientIdAlertsAlertId(patientId,alertId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePatientsPatientIdAlertsAlertIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>>
    
    export type DeletePatientsPatientIdAlertsAlertIdMutationError = void | ErrorApiOutContract

    export const useDeletePatientsPatientIdAlertsAlertId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>, TError,{patientId: string;alertId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePatientsPatientIdAlertsAlertId>>,
        TError,
        {patientId: string;alertId: string},
        TContext
      > => {

      const mutationOptions = getDeletePatientsPatientIdAlertsAlertIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdAlertsMarkasread = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/alerts/markasread`, method: 'PUT'
    },
      options);
    }
  


export const getPutPatientsPatientIdAlertsMarkasreadMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['putPatientsPatientIdAlertsMarkasread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  putPatientsPatientIdAlertsMarkasread(patientId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdAlertsMarkasreadMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>>
    
    export type PutPatientsPatientIdAlertsMarkasreadMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdAlertsMarkasread = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdAlertsMarkasread>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdAlertsMarkasreadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    